"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.CheckBoxLabel = styled_components_1.default.label `
  &:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    ${({ theme: { isRTL } }) => isRTL ? `margin-left:5px;` : `margin-right:5px;`}
    width: 20px;
    height: 20px;
    border: 1px solid #000;
    border-radius: 4px;
    background-color: #fff;
    transition: all 0.1s ease 0s;
  }
  &:after {
    width: 6px;
    height: 12px;
    border: 2px solid #fff;
    position: absolute;
    display: none;
    content: "";
    transform: rotate(45deg);
    top: 2px;
    border-top: 0;
    border-left: 0;
    ${({ theme: { isRTL } }) => isRTL ? `right: 6.5px;` : `left: 6.5px;`}
  }
  &.checked:before {
    border-color: #3e97eb;
    background-color: #0179ff;
  }
  &.checked:after {
    display: inline-block;
    vertical-align: middle;
  }
`;
